const resolve = (correlationId, args) => (
  typeof correlationId === 'function' ? correlationId(args) : correlationId
);

const withCorrelationId = (defaultCorrelationId) => ({
  functionName,
  call,
  ...otherMethods
}) => {
  const customCall = ({
    fetchClient = fetch,
    getState,
    args: {
      correlationId: argsCorrelationId,
      ...otherArgs
    } = {},
    ...rest
  }) => {
    const customFetch = (url, fetchOpts) => {
      const { headers: { 'one-data-correlation-id': oneDataCorrelationId } } = fetchOpts;
      const resolveArgs = { getState, functionName, args: otherArgs };
      const correlationId = resolve(argsCorrelationId, resolveArgs)
        || resolve(defaultCorrelationId, resolveArgs)
        || oneDataCorrelationId;

      return fetchClient(url, {
        ...fetchOpts,
        headers: {
          ...fetchOpts.headers,
          'one-data-correlation-id': correlationId,
        },
      });
    };

    return call({
      fetchClient: customFetch,
      getState,
      args: otherArgs,
      ...rest,
    });
  };

  return {
    functionName,
    call: customCall,
    ...otherMethods,
  };
};

export default withCorrelationId;
